export default __webpack_public_path__ + "static/media/9.683b1d7d.jpg";